import messagesForCardBuilder from "../../../../../../_themes/first-commonwealth-theme/src/shared/js/utils/messagesForCardBuilder.mjs";
const amountToBorrow = "How much will you need to achieve your goal?";
const amountSaved = "How much have you saved for your goal?";
const loanTiming = "How soon will you need the money?";
const loanAccess = 'If you want to borrow, how do you want to access your money?';
const loanTimingOptions = {
  now: 'Now',
  less: 'Less than 1 Year',
  three: '3 months',
  six: '6 months',
  twelve: '1 year',
  more: 'Over 1 Year',
};

export default {
  productTypePreference: 'To best understand where you are in your financial journey, let’s walk through our guide.',

  accountBalancesFCWQuestionGroup:
  'Let’s review your First Commonwealth deposit balances:',
  loanBalancesFCWQuestionGroup: 'Let’s review your First Commonwealth loan balances:',

  'goalsQuestionGroup': 'Understanding your goals is critical to helping you build a pathway to financial confidence. Please help us understand your current goals.',

  'goalsQuestionGroup.subtext': 'No goals yet? Click next to continue.',

  'summary.norecommendations': "<p>We’re excited to partner with you on your financial journey, and we have solutions to help manage, save, borrow and protect your money. In order to recommend the best solutions for you, we need to understand more about your current finances and goals. You can return to the guide by clicking the &quot;Back to Guide&quot; button at the top of the page.</p><p>If you’re not quite sure what your financial goals are, the Saving for the Future goal is a good place to start. Our team is also available to provide personal service by phone at 844.711.BANK (2265) or in person at your local community office.</p>",
  
  //goal cards
  'goalTypes.futureGoal': 'Saving for the Future',
  'goalTypes.futureGoal.title': 'Saving for the Future',
  'futureGoal.cardBuilder.title': '<i class="fa fa-clock-o"></i><div>Saving for the Future</div>',
  'details.futureGoalAmount': `Goals: Saving for the Future | ${amountToBorrow}`,
  'details.futureGoalAmountSaved': `Goals: Saving for the Future | ${amountSaved}`,

  'goalTypes.childGoal': 'Saving for a Child or Grandchild',
  'goalTypes.childGoal.title': 'Saving for a Child or Grandchild',
  'childGoal.cardBuilder.title': '<i class="fa fa-child"></i><div>Saving for a Child or Grandchild</div>',
  'details.childGoalAmount': `Goals: Saving for a Child or Grandchild | ${amountToBorrow}`,
  'details.childGoalAmountSaved': `Goals: Saving for a Child or Grandchild | ${amountSaved}`,
  'details.childGoalTiming': `Goals: Saving for a Child or Grandchild | ${loanTiming}`,
  'childGoalTiming.1': loanTimingOptions.now,

  'educationGoalTiming.1': loanTimingOptions.now,

  'goalTypes.majorPurchaseGoal': 'Major Purchase',
  'goalTypes.majorPurchaseGoal.title': 'Major Purchase',
  'majorPurchaseGoal.cardBuilder.title': '<i class="fa fa-usd"></i><div>Major Purchase</div>',
  'details.majorPurchaseGoalAmount': `Goals: Major Purchase | ${amountToBorrow}`,
  'details.majorPurchaseGoalAmountSaved': `Goals: Major Purchase | ${amountSaved}`,
  'details.majorPurchaseGoalTiming': `Goals: Major Purchase | ${loanTiming}`,
  'majorPurchaseGoalTiming.1': loanTimingOptions.now,
  
  'goalTypes.lifeEventGoal': 'Major Life Event',
  'goalTypes.lifeEventGoal.title': 'Major Life Event',
  'lifeEventGoal.cardBuilder.title': '<i class="fa fa-university"></i><div>Major Life Event</div>',
  'details.lifeEventGoalAmount': `Goals: Major Life Event | ${amountToBorrow}`,
  'details.lifeEventGoalAmountSaved': `Goals: Major Life Event | ${amountSaved}`,
  'details.lifeEventGoalTiming': `Goals: Major Life Event | ${loanTiming}`,
  'details.lifeEventGoalAccess': `Goals: Major Life Event | ${loanAccess}`,
  'lifeEventGoalTiming.1': loanTimingOptions.now,
  
  'goalTypes.homeGoal': 'Buy a Home',
  'goalTypes.homeGoal.title': 'Buy a Home',
  'homeGoal.cardBuilder.title': '<i class="fa fa-home"></i><div>Buy a Home</div>',
  'details.homeGoalAmount': `Goals: Buy a Home | ${amountToBorrow}`,
  'details.homeGoalAmountSaved': `Goals: Buy a Home | ${amountSaved}`,
  'details.homeGoalTiming': `Goals: Buy a Home | ${loanTiming}`,
  'details.homeGoalAccess': `Goals: Buy a Home | ${loanAccess}`,
  'homeGoalTiming.1': loanTimingOptions.now,

  'homeImprovementGoalTiming.1': loanTimingOptions.now,

  'goalTypes.retirementGoal': 'Retirement Planning',
  'goalTypes.retirementGoal.title': 'Retirement Planning',
  'retirementGoal.cardBuilder.title': '<i class="fa fa-money"></i><div>Retirement Planning</div>',
  'details.retirementGoalAmount': `Goals: Retirement Planning | ${amountToBorrow}`,
  'details.retirementGoalAmountSaved': `Goals: Retirement Planning | ${amountSaved}`,
  'details.retirementGoalTiming': `Goals: Retirement Planning | ${loanTiming}`,
};
